// Separate file to make testing easier — mirrors the pattern used by
// dynamicImportAgent for the FingerprintJS SDK.

type CastleModule = typeof import('@castleio/castle-js');

let castleModulePromise: Promise<CastleModule> | undefined;

function loadCastleModule(): Promise<CastleModule> {
  if (!castleModulePromise) {
    castleModulePromise = import('@castleio/castle-js').catch((error: unknown) => {
      castleModulePromise = undefined;
      throw error;
    });
  }
  return castleModulePromise;
}

export async function configureCastle(publishableKey: string): Promise<void> {
  const { configure } = await loadCastleModule();
  configure({ pk: publishableKey });
}

export async function createCastleRequestToken(): Promise<string> {
  const { createRequestToken } = await loadCastleModule();
  const token = await createRequestToken();
  return typeof token === 'string' ? token : '';
}

/**
 * Reset internal state. Intended for use in tests only.
 * @internal
 */
export function resetCastleModuleForTests(): void {
  castleModulePromise = undefined;
}
